import React from 'react';
import clsx from 'clsx';

import Button from '@common/Button';
import Container from '@common/Container';
import Section from '@common/Section';
import Heading from '@common/Heading';
import Img from '@common/Image';
import Row from '@common/Row';
import RichText from '@common/RichText';

const Default = ({ data }) => {
  const {
    title,
    description,
    images,
    color,
    benefits,
    tagline,
    button
  } = data;
  return (
    <Section spacing='mb-5'>
      <Container>
        <Row>
          <div className='col border py-4 px-3'>
            <div className='d-flex justify-content-between'>
              {title && <Heading type='h3' className='mb-3'>{title}</Heading>}
              {images &&
                <div className='d-flex'>
                  {images.map((image, index) => (
                    <Img key={index} image={image.gatsbyImageData}  file={image.file} className={clsx({'me-3':index+1 !== images.length })}/>
                  ))}
                </div>
              }
            </div>
            {description && <RichText json={description} p='fs-16'/>}
            <div className={clsx('w-100', {[`bg-${color}`]:color})} style={{height: '16px'}}/>  
            {benefits && benefits.map((benefit, index) => {
              if (benefit.__typename === 'ContentfulListBlock') {
                return (
                  <Row className='row-cols-md-2 row-cols-lg-4 mt-4' key={index}>
                    {(benefit.title && benefit.showTitle) && <p className='fs-14 mb-1'>{benefit.title}</p>}
                    {benefit.list && benefit.list.map(((item, i)=>(
                      <div key={i}>
                        {(item.title && item.showTitle) && <p className='fs-14 mb-1'>{item.title}</p>}
                        <RichText ul='list-checkmark-black mb-0' p='mb-1 fs-14' json={item.text}/>
                      </div>
                    )))}
                  </Row>
                )
              } else if (benefit.__typename === 'ContentfulTextBlock') {
                return (
                  <div key={index} className='border-bottom pb-2 mt-4 mb-2'>
                    {(benefit.title && benefit.showTitle) && <p className='mb-1'>{benefit.title}</p>}
                    <RichText p='mb-1 fs-16' json={benefit.text}/>
                  </div>
                )
              }
            })}
            {button &&
              <div className='border-top pt-3 mt-3'>
                {tagline && <div className='fs-24 fw-extrabold mb-3'>{tagline}</div>}
                <Button
                  variant={button.variant}
                  to={button.link}
                  addClass={clsx('shadow scale-1 mb-3 fs-18', button.class)}
                  copy={button.copy}
                  style={{padding:'15px 55px'}}
                />
              </div>
            }
          </div>
        </Row>
      </Container>
    </Section>
  )
}

export default Default
